import { Alert, PageLoading } from "@vjal/ui";
import type { CoachingZ6Binding } from "../hooks/useCoachingZ6Data";

/**
 * Honest live posture for the Z6 read surfaces, mirroring LiveListStatus.
 *
 * Renders nothing in mock/evidence mode. In live mode it renders exactly one of
 * loading / denied / error. The error state covers an ABSENT backend Z-route
 * (the routes are not deployed until Z7) so a surface degrades gracefully to an
 * honest "not yet available" message instead of crashing. Backend `CO-`
 * references are surfaced verbatim for traceability.
 */
export function Z6BindingStatus({ binding, label }: { binding: CoachingZ6Binding<unknown>; label: string }) {
  if (!binding.isLiveBound) return null;
  if (binding.isLoading) {
    return (
      <div data-honest-posture="loading">
        <PageLoading label={`Loading ${label}`} lines={2} className="px-0 py-4" />
      </div>
    );
  }
  if (binding.denied) {
    return (
      <Alert variant="info">
        {`The live service denied ${label} for this role scope${referenceSuffix(binding.reference)}.`}
      </Alert>
    );
  }
  if (binding.isError) {
    return (
      <Alert variant="warning">
        {`${capitalize(label)} are not yet available${referenceSuffix(binding.reference)}. This surface is ready and will populate once the coaching Zoom routes are deployed.`}
      </Alert>
    );
  }
  return null;
}

function referenceSuffix(reference?: string) {
  return reference ? ` (ref ${reference})` : "";
}

function capitalize(value: string) {
  return value.length === 0 ? value : value[0].toUpperCase() + value.slice(1);
}
